import React from 'react'
import Skeleton from '../Skeleton/Skeleton'
import styles from './ProductPageSkeleton.module.css'

export default function ProductPageSkeleton() {
  return (
    <div className={styles.productPageSkeleton}>
      <div className={styles.gallerySkeleton}>
        {/* Main Image */}
        <Skeleton
          width="100%"
          height="33.33vw"
          variant="rounded"
          className={styles.mainImageSkeleton}
        />

        {/* Thumbnails */}
        <div className={styles.thumbnailsSkeleton}>
          {[...Array(4)].map((_, index) => (
            <Skeleton
              key={index}
              width="4.17vw"
              height="4.17vw"
              variant="rounded"
              className={styles.thumbnailSkeleton}
            />
          ))}
        </div>
      </div>

      <div className={styles.infoSkeleton}>
        {/* Tags */}
        <div className={styles.tagsSkeleton}>
          <Skeleton width="4.17vw" height="1.67vw" variant="rounded" />
          <Skeleton width="5.21vw" height="1.67vw" variant="rounded" />
        </div>

        {/* Category */}
        <Skeleton width="6.25vw" height="1.04vw" variant="text" />

        {/* Title */}
        <Skeleton width="80%" height="3.13vw" variant="text" />

        {/* Description */}
        <Skeleton width="100%" height="2.08vw" variant="text" />
        <Skeleton width="70%" height="2.08vw" variant="text" />

        {/* Specifications */}
        <div className={styles.specsSkeleton}>
          {[...Array(5)].map((_, index) => (
            <div key={index} className={styles.specItemSkeleton}>
              <Skeleton width="8.33vw" height="1.04vw" variant="text" />
              <Skeleton width="12.5vw" height="1.04vw" variant="text" />
            </div>
          ))}
        </div>

        {/* Options */}
        <div className={styles.optionsSkeleton}>
          {[...Array(3)].map((_, index) => (
            <div key={index} className={styles.optionSkeleton}>
              <Skeleton width="6.25vw" height="1.04vw" variant="text" />
              <Skeleton width="8.33vw" height="2.08vw" variant="rounded" />
            </div>
          ))}
        </div>

        {/* Quantity */}
        <div className={styles.quantitySkeleton}>
          <Skeleton width="6.25vw" height="1.04vw" variant="text" />
          <Skeleton width="8.33vw" height="2.08vw" variant="rounded" />
        </div>

        {/* Price */}
        <Skeleton width="8.33vw" height="2.08vw" variant="text" />

        {/* Actions */}
        <div className={styles.actionsSkeleton}>
          <Skeleton width="100%" height="3.13vw" variant="rounded" />
          <Skeleton width="100%" height="3.13vw" variant="rounded" />
        </div>

        {/* Accordion */}
        <div className={styles.accordionSkeleton}>
          {[...Array(3)].map((_, index) => (
            <Skeleton
              key={index}
              width="100%"
              height="2.5vw"
              variant="rounded"
              className={styles.accordionItemSkeleton}
            />
          ))}
        </div>
      </div>
    </div>
  )
}
